import Mutations from '../../odata/mutations';

export default { ...new Mutations('address'), ...new Mutations('addresses') };
